import React from 'react';
import { Users, Star, TrendingUp } from 'lucide-react';
import { stats as defaultStats } from '../data/mockData';
import { useLanguage } from '../context/LanguageContext';
import { useParticipantCount } from '../context/ParticipantContext';

const Stats = () => {
  const { language } = useLanguage();
  const { formatted: participantCount } = useParticipantCount();
  
  const statItems = [
    {
      icon: Users,
      value: participantCount,
      label: language === 'nl' ? 'HR-professionals beoordeeld' : 'HR Professionals Assessed',
      color: 'text-blue-500',
      bgColor: 'bg-blue-100',
    },
    {
      icon: Star,
      value: defaultStats.rating,
      label: language === 'nl' ? 'Gemiddelde workshop beoordeling' : 'Average Workshop Rating',
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-100',
    },
    {
      icon: TrendingUp,
      value: defaultStats.implementRate,
      label: language === 'nl' ? 'Implementatie binnen 3 maanden' : 'Implement Within 3 Months',
      color: 'text-green-500',
      bgColor: 'bg-green-100',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {statItems.map((stat, index) => (
            <div
              key={stat.label}
              className="text-center p-8 rounded-2xl bg-gray-50 hover:shadow-lg transition-shadow duration-300"
            >
              <div className={`w-16 h-16 ${stat.bgColor} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
                <stat.icon className={`h-8 w-8 ${stat.color}`} />
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">
                {stat.value}
              </div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
